import { createContext, useContext, useEffect, useState } from "react";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { loginUrl } from "../helpers/ApiPresensi";
import {
  decryptLocalStorage,
  encryptLocalStorage,
  removeLocalStorageItem,
} from "../helpers/SecureStorage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const getDeviceId = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  };

  const getIpAddress = async () => {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data.ip;
  };

  useEffect(() => {
    const token = decryptLocalStorage(
      process.env.REACT_APP_LOCAL_STORAGE_TOKEN,
    );

    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const login = async (username, password) => {
    const deviceId = await getDeviceId();
    const ip_address = await getIpAddress();

    const body = {
      username: username,
      password: password,
      device_id: deviceId,
      ip_address: ip_address,
      app_version: "1.2",
      app_name: "presensipegawaiweb",
      app_package: "presensipegawaiweb",
    };

    try {
      const response = await fetch(loginUrl, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || "Login gagal");
      }

      setIsAuthenticated(true);

      encryptLocalStorage(
        process.env.REACT_APP_LOCAL_STORAGE_TOKEN,
        data.access_token,
      );

    } catch (error) {
      setIsAuthenticated(false);
      throw error;
    }
  };

  const logout = () => {
    removeLocalStorageItem(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

    // localStorage.removeItem("api_key");
    // localStorage.removeItem("username");
    // localStorage.removeItem("lokasiList");
    // localStorage.removeItem("shiftList");
    // localStorage.removeItem("shift");
    // localStorage.removeItem("nama");
    // localStorage.removeItem("jenispegawai");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
